const Send = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <mask
      id="mask0_1747_9448"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="18"
      height="18"
    >
      <rect width="18" height="18" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1747_9448)">
      <path
        d="M2.625 14.4375V10.2548L7.81725 9L2.625 7.74525V3.5625L15.5336 9L2.625 14.4375Z"
        fill="#A4A7AE"
      />
    </g>
  </svg>
);

export default Send;
